<overlay-panel
	*transloco="let t"
	[isOpen]="searchModalService.isOpen()"
	[title]="t('actions.search')"
	[contentScrolls]="true"
	[wide]="true"
	(closed)="handleClose()"
>
<!-- Fills the panel, so recent searches can sit at its foot, as designed. -->
<div class="search-body">
<search-input
	variant="panel"
	resultsLayout="inline"
	[minSearchChars]="minSearchChars()"
	[loading]="isLoading()"
	[hasResults]="hasResults()"
	(searched)="handleSearch($event)"
	(cleared)="handleCleared()"
	(navigated)="handleNavigate($event)"
	(submitted)="handleSubmit()"
>
	<!-- The same box as results, so switching scope here keeps the tabs in place. -->
	<div empty class="results-block">
		<div class="results-box">
			<div class="results-header">
				<span class="results-heading">{{ t('other.searchResults') }}</span>
				<search-scope-tabs [scope]="searchModalService.scope()" (scopeChange)="handleScopeChange($event)" />
			</div>

			<div class="results-panel is-empty">
				<p class="no-results">{{ t('message.info.noSearchResultsFound') }}</p>
			</div>
		</div>
	</div>

	<div results class="results-block">
		<div class="results-box">
			<div class="results-header">
				<span class="results-heading">{{ t('other.searchResults') }}</span>
				<search-scope-tabs [scope]="searchModalService.scope()" (scopeChange)="handleScopeChange($event)" />
			</div>

			<div class="results-panel">
			@for (section of view().sections; track section.key) {
				<div class="section-header">{{ t(section.titleKey) }}</div>

				<!-- Games are a grid of tiles on desktop; everything else is a list. -->
				@let asTiles = isDesktop() && section.key === 'game';
				<div class="section-items" [class.is-grid]="asTiles">
				@for (item of section.items; track item.key) {
					<div
						#resultRow
						class="result-row"
						[class.is-game]="item.type === 'game'"
						[class.is-tile]="asTiles"
						tabindex="0"
						[class.selected]="item.flatIndex === selectedIndex()"
						(click)="handleSelect(item)"
						(keydown.enter)="handleSelect(item)"
					>
						@switch (item.type) {
							@case ('match') {
								<match-panel-card [item]="item" />
							}
							@case ('tournament') {
								<tournament-panel-card [item]="item" />
							}
							@case ('game') {
								@if (asTiles) {
									<search-game-tile [game]="item.data" />
								} @else {
									<game-panel-card [item]="item" />
								}
							}
						}
					</div>
				}
				</div>
			}
			</div>
		</div>
	</div>
</search-input>

@if (recentSearchesVisible()) {
	<div class="search-extras">
		<recent-searches
			[terms]="recentTerms()"
			(termSelected)="handleRecentSelected($event)"
			(termRemoved)="handleRecentRemoved($event)"
			(clearAllClicked)="handleRecentClearAll()"
		/>

		@if (suggestedGamesVisible()) {
			<div class="suggested">
				<span class="suggested-title">{{ t('other.suggestedGames') }}</span>

				<div class="suggested-row">
					@for (game of suggestedGames(); track game.gameId) {
						<button type="button" class="suggested-game" (click)="handleSuggestedGame(game)">
							<search-game-tile appearance="plain" [game]="game" />
						</button>
					}
				</div>
			</div>
		}
	</div>
}
</div>
</overlay-panel>
